import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import getFolderOperation from 'owa-service/lib/operation/getFolderOperation';
import FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import folderId from 'owa-service/lib/factory/folderId';
import getFolderRequest from 'owa-service/lib/factory/getFolderRequest';
import folderResponseShape from 'owa-service/lib/factory/folderResponseShape';
import BaseFolderId from 'owa-service/lib/contract/BaseFolderId';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ArrayOfResponseMessages from 'owa-service/lib/contract/ArrayOfResponseMessages';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import PublicFolderRequestInit from './utils/PublicFolderRequestInit';

export default function getPublicFolders(
    targetFolderId: string[]
): Promise<ArrayOfResponseMessages<FolderInfoResponseMessage>> {
    let folderIds: BaseFolderId[] = [];
    targetFolderId.forEach(element => {
        folderIds.push(folderId({ Id: element }));
    });

    const defaultAnchorMailbox = getUserConfiguration().SessionSettings.DefaultPublicFolderMailbox;
    if (folderIds.length === 0 || !defaultAnchorMailbox) {
        return null;
    }

    return getFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: getFolderRequest({
                FolderShape: folderResponseShape({
                    BaseShape: 'AllProperties',
                    AdditionalProperties: [propertyUri({ FieldURI: 'ReplicaList' })],
                }),
                FolderIds: folderIds,
            }),
        },
        PublicFolderRequestInit(defaultAnchorMailbox)
    )
        .then(response => {
            return response.Body.ResponseMessages;
        })
        .catch(() => {
            return null;
        });
}
